module.exports = __webpack_public_path__ + "img/two.bf5f7280.png";